import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Config } from "src/app/config/api.config";
import { RoutineRequest } from "../routine.model";
import { PagedResponse } from "@app/models/paged-response";

@Injectable({
  providedIn: "root",
})
export class RoutinesService {
  constructor(private http: HttpClient) {}

  findAll(page: number, size: number, sort?: string, direction?: string): Observable<PagedResponse<any>> {
    let params = new HttpParams().set("page", page).set("size", size);

    if (sort) {
      params = params.set("sort", `${sort},${direction || "asc"}`);
    }

    return this.http.get<PagedResponse<any>>(`${Config.webApiUrl}/v1/routine`, { params });
  }

  findAllByMe(): Observable<any[]> {
    return this.http.get<any[]>(`${Config.webApiUrl}/v1/routine/me`);
  }

  findById(id: string): Observable<any> {
    return this.http.get<any>(`${Config.webApiUrl}/v1/routine/${id}`);
  }

  create(routineRequest: RoutineRequest): Observable<any> {
    return this.http.post<any>(`${Config.webApiUrl}/v1/routine`, routineRequest);
  }

  update(id: string, routineRequest: RoutineRequest): Observable<any> {
    return this.http.put<any>(`${Config.webApiUrl}/v1/routine/${id}`, routineRequest);
  }

  delete(id: string): Observable<any> {
    return this.http.delete<any>(`${Config.webApiUrl}/v1/routine/${id}`);
  }
}
